import React from "react";
import PropTypes from "prop-types";

import "./IOSToggle.scss";

export class IOSToggle extends React.Component {
  state = {};
  render() {
    return (
      <div className="toggleWrapper">
        <input
          type="checkbox"
          name="toggle1"
          className="mobileToggle"
          id="toggle1"
          checked={this.props.checked}
          defaultChecked
        />
        <label htmlFor="toggle1" />
      </div>
    );
  }
}

IOSToggle.propTypes = {
  checked: PropTypes.bool
};
